<template>
    <v-container fluid class="container-full-bg-gray">
        <v-snackbar
            v-model="screen_data.snackbar.isVisible"
            :color="screen_data.snackbar.color"
            :timeout="screen_data.snackbar.timeout"
            >
            {{ screen_data.snackbar.text }}
        </v-snackbar>

        <app-row>
            <app-col cols="12">
                <v-card width="100%" class="rounded-lg">
                    <v-card-title class="d-flex">
                        <div class="mr-auto d-flex align-sm-center">
                            <v-btn v-if="companydb_id" icon
                                @click="$router.push({ name: 'home', params: { 'companydb_id': companydb_id } })">
                                <AppIcon :src="require('../assets/back-arrow.svg')" :size="29" />
                            </v-btn>
                            <h4 class="primary_blue--text ml-2">Invoice Template Playground</h4>
                        </div>
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn
                                color="success"
                                class="mr-2"
                                @click="showSaveDialog = true"
                                :disabled="!templateCode"
                            >
                                <v-icon left>mdi-content-save</v-icon>
                                Save Template
                            </v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                    class="ml-1 mr-2"
                                    icon
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="loadSampleInvoice()"
                                        :loading="screen_data.loading">
                                        <v-icon>mdi-refresh</v-icon>
                                    </v-btn>
                                </template>
                                <span>Load Sample Invoice</span>
                            </v-tooltip>
                        </div>

                    </v-card-title>
                    <v-divider></v-divider>

                    <!-- SECCIÓN: Sample Invoice Selection -->
                    <v-card-text class="section-container">
                        <app-row>
                            <app-col cols="12">
                                <h3 class="section-title mb-4">
                                    <v-icon left color="primary">mdi-file-document</v-icon>
                                    Sample Invoice Data
                                </h3>
                            </app-col>
                        </app-row>
                        <app-row>
                            <app-col cols="6">
                                <v-select
                                    label="Select Sample Invoice"
                                    outlined
                                    dense
                                    :items="sampleInvoiceOptions"
                                    v-model="selectedSampleInvoice"
                                    item-text="name"
                                    item-value="value"
                                    prepend-inner-icon="mdi-file-outline"
                                    @change="loadSampleInvoice"
                                >
                                </v-select>
                            </app-col>
                            <app-col cols="6">
                                <v-text-field
                                    label="Total Pages"
                                    outlined
                                    dense
                                    type="number"
                                    v-model.number="totalPages"
                                    prepend-inner-icon="mdi-file-multiple"
                                >
                                </v-text-field>
                            </app-col>
                        </app-row>
                    </v-card-text>

                    <!-- SECCIÓN: Generación de templates -->
                    <v-divider></v-divider>
                    <v-card-text class="section-container">
                        <app-row>
                            <app-col cols="12">
                                <h3 class="section-title mb-4">
                                    <v-icon left color="primary">mdi-robot</v-icon>
                                    AI Template Generation
                                </h3>
                            </app-col>
                        </app-row>
                        <app-row>
                            <v-col cols="10">
                                <v-textarea
                                    label="Prompt: Describe the invoice template you want"
                                    outlined
                                    v-model="prompt"
                                    rows="3"
                                    placeholder="Example: Create a modern invoice template with a blue header, company logo on the left, invoice details on the right, and a table with line items..."
                                >
                                </v-textarea>
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    class="mt-4"
                                    color="primary"
                                    :loading="generating"
                                    @click="generate()"
                                    >Generate Template</v-btn>
                            </v-col>
                        </app-row>
                        <app-row>
                            <v-textarea
                                label="Invoice Template (HTML/Vue)"
                                outlined
                                rows="15"
                                v-model="templateCode"
                                hint="The Vue template for your invoice. Available components: VCard, VBtn, VTextField, VDataTable, etc."
                                persistent-hint
                            >
                            </v-textarea>
                        </app-row>
                        <app-row>
                            <v-textarea
                                label="Component Options (JavaScript - methods, computed, data)"
                                outlined
                                rows="10"
                                v-model="templateOptions"
                                hint="Define custom methods, computed properties, and data. Example: { data: () => ({ customField: 'value' }), computed: { customTotal() { return this.invoiceable.total_amount * 1.1 } }, methods: { customFormat(v) { return v.toUpperCase() } } }"
                                persistent-hint
                            >
                            </v-textarea>
                        </app-row>
                        <app-row>
                            <v-col cols="10">
                                <v-textarea
                                    label="Request Modifications"
                                    outlined
                                    v-model="prompt_2"
                                    rows="2"
                                    placeholder="Example: Make the header green, add a footer with payment instructions, increase font size for totals..."
                                >
                                </v-textarea>
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    class="mt-4"
                                    color="secondary"
                                    :loading="generating"
                                    @click="modify_generation()"
                                    >Modify Template</v-btn>
                            </v-col>
                        </app-row>
                    </v-card-text>

                    <!-- SECCIÓN: Preview -->
                    <v-divider></v-divider>
                    <v-card-text class="section-container">
                        <app-row>
                            <app-col cols="12">
                                <h3 class="section-title mb-4">
                                    <v-icon left color="primary">mdi-eye</v-icon>
                                    Live Preview
                                </h3>
                            </app-col>
                        </app-row>
                        <app-row v-if="templateCode && samplePageData">
                            <v-col cols="12">
                                <v-card outlined class="preview-card">
                                    <v-card-subtitle class="pb-2">
                                        <v-chip small color="primary" text-color="white">
                                            Page {{ currentPage }} of {{ totalPages }}
                                        </v-chip>
                                    </v-card-subtitle>
                                    <v-divider></v-divider>
                                    <v-card-text class="preview-content">
                                        <DynamicInvoiceViewerComponent
                                            v-if="samplePageData"
                                            :key="previewKey"
                                            :page="pageWithTemplate"
                                            :num_page="currentPage"
                                            :total_pages="totalPages"
                                        />
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </app-row>
                        <app-row v-else>
                            <v-col cols="12">
                                <v-alert type="info" text outlined>
                                    <div class="d-flex align-center">
                                        <v-icon left>mdi-information</v-icon>
                                        <div>
                                            <strong>No template configured yet.</strong>
                                            <p class="mb-0 mt-2">Use the AI Template Generation section above to create your custom invoice template.</p>
                                        </div>
                                    </div>
                                </v-alert>
                            </v-col>
                        </app-row>
                    </v-card-text>

                    <!-- SECCIÓN: Documentation -->
                    <v-divider></v-divider>
                    <v-card-text class="section-container">
                        <app-row>
                            <app-col cols="12">
                                <h3 class="section-title mb-4">
                                    <v-icon left color="primary">mdi-book-open-variant</v-icon>
                                    Documentation & Available Properties
                                </h3>
                            </app-col>
                        </app-row>
                        <app-row>
                            <v-col cols="12">
                                <v-expansion-panels accordion>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <div>
                                                <v-icon left small>mdi-code-braces</v-icon>
                                                <strong>Available Data Properties</strong>
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <pre class="code-block">{{ availableDataDocs }}</pre>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <div>
                                                <v-icon left small>mdi-function</v-icon>
                                                <strong>Available Methods</strong>
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <pre class="code-block">{{ availableMethodsDocs }}</pre>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <div>
                                                <v-icon left small>mdi-calculator</v-icon>
                                                <strong>Available Computed Properties</strong>
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <pre class="code-block">{{ availableComputedDocs }}</pre>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            <div>
                                                <v-icon left small>mdi-puzzle</v-icon>
                                                <strong>Available Vuetify Components</strong>
                                            </div>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <pre class="code-block">{{ vuetifyComponentsDocs }}</pre>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </app-row>
                    </v-card-text>
                </v-card>
            </app-col>
        </app-row>

        <!-- Save Template Dialog -->
        <v-dialog v-model="showSaveDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Save Invoice Template</span>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="templateName"
                        label="Template Name"
                        outlined
                        dense
                        placeholder="e.g., Modern Blue Template"
                        :rules="[v => !!v || 'Name is required']"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showSaveDialog = false">Cancel</v-btn>
                    <v-btn
                        color="success"
                        @click="saveTemplate"
                        :loading="saving"
                        :disabled="!templateName"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import AppRow from "@/components/layout/AppRow.vue";
import AppCol from "@/components/layout/AppCol.vue";
import DynamicInvoiceViewerComponent from "@/modules/facturae/infra/pdf_view/DynamicInvoiceViewerComponent.vue";
import { InvoiceTemplatePlaygroundComponent } from "@/modules/facturae/app/InvoiceTemplatePlaygroundComponent.ts";
import { InvoiceTemplateApiRepository } from "@/modules/facturae/infra/InvoiceTemplateApiRepository.ts";
import { DEFAULT_INVOICE_TEMPLATE } from "@/modules/facturae/infra/pdf_view/DefaultInvoiceTemplate.js";

export default {
    name: "InvoiceTemplatePlayground",
    components: {
        AppRow,
        AppCol,
        DynamicInvoiceViewerComponent
    },
    data() {
        return {
            screen_data: {
                loading: false,
                snackbar: {
                    isVisible: false,
                    color: 'success',
                    timeout: 3000,
                    text: ''
                }
            },
            templateCode: '',
            templateOptions: null,
            prompt: '',
            prompt_2: '',
            generating: false,
            samplePageData: null,
            currentPage: 1,
            totalPages: 1,
            selectedSampleInvoice: 'basic',
            sampleInvoiceOptions: [
                { name: 'Basic Invoice', value: 'basic' },
                { name: 'Invoice with Discounts', value: 'discounts' },
                { name: 'Invoice with Taxes', value: 'taxes' },
                { name: 'Complex Invoice', value: 'complex' }
            ],
            playgroundComponent: null,
            showSaveDialog: false,
            templateName: '',
            saving: false,
            availableDataDocs: `invoiceable - The invoice/facturae object
configuration - Company configuration
rectified_inv - Rectified invoice reference
total_lines - Total number of line items`,
            availableMethodsDocs: `formatCurrency(value) - Formats number as currency (e.g., 1.234,56 €)
payment_message(payment_means) - Returns payment method description
get_total_amount(invoice_line) - Calculates total for an invoice line
formatInvoiceDate(date) - Formats date from YYYY-MM-DD to DD/MM/YYYY
formatField(field) - Formats tax rate fields (e.g., 0.21 → '21%')`,
            availableComputedDocs: `proformaHeader - Proforma header info (if applicable)
presupuestoHeader - Budget header info (if applicable)
computed_lines - All invoice lines with additional descriptions
tax_type_to_show - Returns 'IVA' or 'IGIC'
im_suplido_only_invoice - Boolean for reimbursable-only invoices
pageIsTotals - Whether this page shows totals
isLastPage - Whether this is the last page
showAdditionalInfo - Whether to show additional info section
showPaymentMessage - Whether to show payment message
showFooter - Whether to show footer
showFooterSmall - Whether to show small footer`,
            vuetifyComponentsDocs: `VCard, VCardTitle, VCardText, VCardActions
VBtn, VTextField, VTextarea
VSpacer, VCol, VRow, VContainer
VCheckbox, VSwitch, VForm
VIcon, VDataTable, VChip, VDivider`
        };
    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: false,
            default: null
        }
    },
    computed: {
        pageWithTemplate() {
            if (!this.samplePageData) return null;
            return {
                ...this.samplePageData,
                templateCode: this.templateCode,
                options: this.templateOptions
            };
        },
        previewKey() {
            return `${this.selectedSampleInvoice}-${this.currentPage}`;
        }
    },
    methods: {
        showSnackbar(text, color = 'success') {
            this.screen_data.snackbar.text = text;
            this.screen_data.snackbar.color = color;
            this.screen_data.snackbar.isVisible = true;
        },
        async generate() {
            if (!this.prompt.trim()) {
                this.showSnackbar('Please enter a prompt first', 'warning');
                return;
            }
            this.generating = true;
            try {
                const result = await this.playgroundComponent.generateTemplate(this.prompt);
                this.templateCode = result.template;
                this.templateOptions = result.options;
                this.showSnackbar('Template generated successfully!');
            } catch (error) {
                this.showSnackbar('Error generating template: ' + error.message, 'error');
            } finally {
                this.generating = false;
            }
        },
        async modify_generation() {
            if (!this.prompt_2.trim()) {
                this.showSnackbar('Please enter modification instructions', 'warning');
                return;
            }
            if (!this.templateCode) {
                this.showSnackbar('Please generate a template first', 'warning');
                return;
            }
            this.generating = true;
            try {
                const result = await this.playgroundComponent.modifyTemplate(
                    this.prompt_2,
                    this.templateCode,
                    this.templateOptions
                );
                this.templateCode = result.template;
                this.templateOptions = result.options;
                this.showSnackbar('Template modified successfully!');
            } catch (error) {
                this.showSnackbar('Error modifying template: ' + error.message, 'error');
            } finally {
                this.generating = false;
            }
        },
        loadSampleInvoice() {
            console.log('Loading sample invoice:', this.selectedSampleInvoice);
            const newData = this.playgroundComponent.getSampleInvoiceData(
                this.selectedSampleInvoice,
                this.currentPage - 1
            );
            console.log('New sample data:', newData);
            // Force reactivity by creating new object
            this.samplePageData = { ...newData };
        },
        async saveTemplate() {
            if (!this.templateName.trim()) {
                this.showSnackbar('Please enter a template name', 'warning');
                return;
            }
            if (!this.templateCode) {
                this.showSnackbar('No template to save', 'warning');
                return;
            }

            this.saving = true;
            try {
                let res = await this.playgroundComponent.saveTemplate({
                    name: this.templateName,
                    template: this.templateCode,
                    options: this.templateOptions
                });
                if (res.error){
                    throw res.error
                }
                this.showSnackbar('Template saved successfully!', 'success');
                this.showSaveDialog = false;
                this.templateName = '';
            } catch (error) {
                console.error('Error saving template:', error);
                this.showSnackbar('Error saving template: ' + (error.message || 'Unknown error'), 'error');
            } finally {
                this.saving = false;
            }
        }
    },
    async mounted() {
        this.playgroundComponent = new InvoiceTemplatePlaygroundComponent(
            new InvoiceTemplateApiRepository(),
            this.companydb_id
        );

        // Load initial sample invoice
        this.loadSampleInvoice();

        // Set default template - complete PageFacturae layout
        this.templateCode = DEFAULT_INVOICE_TEMPLATE;
    }
};
</script>

<style scoped>
.section-container {
    background-color: #fafafa;
    padding: 24px !important;
    margin-bottom: 0;
}

.section-title {
    color: #1976d2;
    font-weight: 500;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
}

.v-divider {
    margin: 0 !important;
}

.preview-card {
    background-color: white;
}

.preview-content {
    min-height: 400px;
    background-color: #f5f5f5;
}

.code-block {
    background-color: #f5f5f5;
    padding: 16px;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 0.875rem;
    overflow-x: auto;
}
</style>
